<template lang="pug">
  .lista-solicitud-vacaciones.contenedor-interno
    .title
      span Reporte de Documentos para Firmar
    transition(
      name='fade',
      tag="div",
      v-if="mostrarModalRechazo"
      )
      .overlay-class
        .card
          header.modal-card-head.display-flex
            p.flex-1
              span Motivo de rechazo
          .card-content
            textarea.p-10(name="motivoRechazo", cols="30", rows="10", v-model="motivoRechazo")
          footer.card-footer
            a.card-footer-item(@click="rechazar")
              span(v-if="isSaving") Rechazar...
              span(v-else) Rechazar
            a.card-footer-item(@click="cerrarModalRechazo")
              strong Cancelar
    transition(
      name='fade',
      tag="div",
      v-if="mostrarModalNotificar"
      )
      confirmar-accion-overlay(
        @close="closeModalNotificar"
        @do="notificar"
        ref="confirmarNotificar"
      )
        span(slot="title") ¿Desea notificar a todos los empleados que no hayan cargado su documento?
        span(slot="primaryAction")
          span(v-if="isProcessing") Notificando...
          span(v-else) Notificar
        strong Este proceso no se puede deshacer
    transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
      .filtros-container(key="filtros-container")
        transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
          .title-filtro(@click="mostrarFiltros = !mostrarFiltros",:class="{'hide-box-shadow': !mostrarFiltros}" , key="title-filtro")
            h2.text filtros
            .caret
              span.icon
                i.fa.fa-caret-down(v-if="mostrarFiltros")
                i.fa.fa-caret-up(v-else)
          .filtros(v-if="mostrarFiltros", key="filtros")
            .filtro
              .codigo-empleado
                .control.title-singular
                  p Empleado
                  .input-container
                    input.input(
                      type="number",
                      v-model="filtros.codigoEmpleado"
                      @focus="mostrarBusquedaEmpleado = true"
                    )
                    span.icon.cursor-pointer.margin-left-5(@click="mostrarBusquedaEmpleado = true")
                      i.fa.fa-search
                    .erase-data(@click="filtros.codigoEmpleado = ''")
                      .icon
                        .fa.fa-times
                transition(name="fade-quick")
                  .pop-over(
                      v-if="mostrarBusquedaEmpleado"
                    )
                      lookup-small-empleado(
                        @selected="seleccionarEmpleado"
                        @close="mostrarBusquedaEmpleado = false"
                        :codigo="filtros.codigoEmpleado"
                      )

            .filtro
              .title-singular
                p Documento
              .select.display-flex
                select.flex-1(v-model='filtros.id' @change="changeFiltro")
                  option(:value="''") Ninguno
                  option(v-for="documento in documentos", :value="documento.id")
                    | {{  documento.descripcion }}

            .filtro
              .title-singular
                p Estado
              .select.display-flex
                select.flex-1(v-model='filtros.estado' @change="changeFiltro")
                  option(:value="0") Todos
                  option(:value="1") Sin carga
                  option(:value="2") Sin revisar
                  option(:value="3") Revisado
            .filtro
              .title-singular
                p ¿Documentos activos?
              .select.display-flex
                select.flex-1(v-model='filtros.activo' @change="changeFiltro")
                  option(:value="0") Todos
                  option(:value="1") Si
                  option(:value="2") No

          .boton-container(key="boton-container")
            button.button.m-5(@click="fetch")
              span.icon.is-small
                i.fa.fa-refresh.fa-fw.fa-lg
              span Refrescar
            button.button.m-5(@click="limpiarFiltros")
              span.icon.is-small
                i.fa.fa-trash.fa-fw.fa-lg
              span Limpiar
            button.button.m-5.is-primary(@click="notificar()")
              span.icon.is-small
                i.fa.fa-envelope.fa-fw.fa-lg
              span Notificar Masivo
      .body(key="body")
        .information
          transition-group.contenedor-data(
            v-infinite-scroll="fetchByScroll"
            infinite-scroll-disabled="disabledScrollExecute"
            infinite-scroll-distance="2"
            name="fade-smooth-two"
            tag="div"
          )
            table.table.is-striped.is-bordered(
              v-if="lista.length !== 0"
              key="lista"
            )
              thead
                th Doc.
                th Empleado
                th
              tbody(
                name="table-row"
                is="transition-group"
              )
                tr.row-table(
                  v-for="(o, index) in lista"
                  :key="index"
                  :class="{'is-close':!o.activo}"
                )
                  td
                    span.hint--top(:aria-label="'ID: ' + o.id") {{ o.descripcion }}
                  td
                    .td-wrapper
                      span.hint--top(:aria-label="'Empleado: ' + o.dniEmpleado") {{ o.nombreEmpleado }}
                      template(v-if="o.rutaSubido")
                        .seen
                          span.has-text-bold Subido
                          span.icon
                            i.fa.fa-check.fs-12
                        .dates-wrapper
                          span.has-text-bold Fecha Subido:&nbsp;
                          span {{ o.fechaSubidoArchivoEmpleado }}
                  td
                    .text-center.flex.fdc
                      .contenedor-acciones
                        a.button.is-small(v-if="o.rutaSubido" :href="o.rutaSubido" target="_blank")
                          span.icon.is-small
                            i.fa.fa-eye.is-small.fs-12
                          span Revisar
                        button.button.is-small(v-if="o.rutaSubido && !o.revisado" @click="revisar(o)" :class="{ 'is-loading': isProcessing }")
                          span.icon.is-small
                            i.fa.fa-check.is-small.fs-12
                          span Aprobar
                        button.button.is-small.is-primary.mt-5(v-if="!o.rutaSubido" @click="notificar(o)")
                          span.icon.is-small
                            i.fa.fa-envelope.fs-12
                          span Notificar
                        button.button.is-small.is-danger.mt-5(v-if="o.rutaSubido" @click="abrirModalRechazo(o)" )
                          span.icon.is-small
                            i.fa.fa-trash.fs-12
                          span Rechazar

        .is-loading(v-if="isLoading")
          .icon
            i.fa.fa-spinner.fa-spin
        .message.is-warning(v-if="lista.length === 0 && !isLoading")
          .message-body
            span.has-text-bold No existe información con los filtros definidos
</template>

<script>
import LookupSmallEmpleado from './Component_Lookup_Small_Empleado.vue'
import { apiGet, apiPost, notify } from '../util/general'
import ConfirmarAccionOverlayComponent from '../components/Component_Confirmar_Accion_Overlay'
export default {
  name: 'reporte_contratos_component',
  data () {
    return {
      lista                     : [],
      isLoading                 : false,
      mostrarBusquedaEmpleado   : false,
      mostrarFiltros            : true,
      filtros                   :{
        activo : 1,
        estado : 0,
        codigoEmpleado: '',
        id: ''
      },
      documentos: [],
      mostrarModalEliminar: false,
      mostrarModalNotificar: false,
      isProcessing: false,
      motivoRechazo:  '',
      mostrarModalRechazo: false,
      disabledScrollExecute: true,
      isScroll               : false,
      documento:{},
      skip                   : 0,
      noMore                 : false,
      isSaving:false
    }
  },
  components: {
    LookupSmallEmpleado,
    'confirmar-accion-overlay': ConfirmarAccionOverlayComponent
  },
  created () {
    this.filtros = {...this.filtros, ...this.$route.query}
    this.fetchDocumentos()
    this.fetch()
  },
  methods: {
    changeFiltro () {
      this.fetch();
    },
    fetchByScroll () {
      var vm = this
      vm.isScroll = true
      vm.fetch()
    },
    fetchDocumentos () {
      var vm = this
      apiGet(vm, '/documentos-firmar/', {}, function (data) {
        vm.documentos = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = { ...vm.filtros }
      vm.disabledScrollExecute = true
      vm.noMore = false
      if (!vm.isScroll) {
        vm.lista = []
        vm.skip = 0
      }
      obj.skip = vm.skip
      apiGet(vm, '/documentos-firmar/reporte', obj, function (data) {
        for (let index = 0; index < data.lista.length; index++) {
          const element = data.lista[index];
          vm.lista.push(element)
        }
        if (data.noMore) {
          vm.noMore = true
          vm.disabledScrollExecute = true
        } else {
          vm.skip += data.lista.length
          vm.disabledScrollExecute = false
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
        vm.isScroll = false
      })
    },
    seleccionarEmpleado (o) {
      this.filtros.codigoEmpleado = o.codigo
    },
    limpiarFiltros () {
      this.filtros = {
        activo : 0,
        estado : 0,
        codigoEmpleado: '',
        id: ''
      }
      this.fetch()
    },
    notificar (o) {
      var vm = this
      if (vm.isProcessing) return
      var obj = {}
      if (o) {
        obj.codigoEmpleado = o.codigoEmpleado
        obj.id = o.id
      } else {
        obj = {...vm.filtros}
      }
      apiPost(vm, '/documentos-firmar/notificar', obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Se le notifico masivamente a los empleados')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isProcessing = false
        vm.mostrarModalNotificar = false
      })
    },
    openModalNotificacionMasiva () {
      this.mostrarModalNotificar = true
    },
    closeModalNotificar () {
      var vm = this
      vm.mostrarModalNotificar = false
    },
    abrirModalRechazo (o) {
      var vm = this
      vm.documento = o
      vm.mostrarModalRechazo = true
    },
    cerrarModalRechazo () {
      var vm = this
      vm.mostrarModalRechazo = false
      vm.documento = {}
      vm.motivoRechazo = null
    },
    revisar (row) {
      var vm = this
      if (vm.isProcessing) return
      vm.isProcessing = true
      var obj = {
        idDetalle: row.idDetalle,
        nombreEmpleado: row.nombreEmpleado
      }
      apiGet(vm, '/documentos-firmar/revisar', obj, function (data) {
        notify(vm, 'success', 'Revisado')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isProcessing = false
        vm.fetch()
      })
    },
    rechazar () {
      var vm = this
      var obj = {
        idDocumento:vm.documento.id,
        nombreEmpleado: vm.documento.nombreEmpleado,
        codigoEmpleado: vm.documento.codigoEmpleado,
        email:vm.documento.email,
        motivo: vm.motivoRechazo
      }

      apiPost(vm, '/documentos-firmar/rechazar', obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Rechazado correctamente')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.mostrarModalNotificar = false
        vm.cerrarModalRechazo()
        vm.fetch()
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .fs-12
    font-size 12px
  .contenedor-interno
    .close
      position absolute
      top 3px
      right 3px
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        // width 100%
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px

  .contenedor-acciones
    display flex
    flex-wrap: wrap;
    .button
      flex 1
      margin 3px 5px

  .is-loading
    margin-top 10px

  .button.is-loading
    margin-top 0px

  .information
    padding-top 10px

  td
    vertical-align: middle;

  is-close
    background-color: #ffd6d6 !important;

  .text-align-center
    text-align center

  .contenedor-frame
    position fixed
    background-color #ccc
    left 1
    top: 0px;
    left: 0px;
    width: 100%;
    height 100vh;
    padding 20px
    transition all 0.5s ease
    z-index: 9999

    .titulo
      display flex
      align-items center
      .texto
        flex 1
        text-align left
        font-size 25px
      .button
        margin-bottom 10px

    iframe
      width 100%
      height calc(100% - 30px);

  .card-footer-item:not(:last-child)
    border-right: 1px solid #dbdbdb
  .info-box-button
    border-radius 0
    border        0px

  .show-break-1
    display none
  .wrapper
    display flex
    justify-content left
    align-items left
    flex-direction column
  @media (max-width: 1035px)
    .filtros
      flex-direction column
      .filtro
        width 100%

  @media (max-width: 650px)
    .show-break-1
      display initial
    .hide-break-1
      display none
    .table
      font-size 12px
      td
        text-align: center
        vertical-align: middle
      .td-wrapper
        display flex
        justify-content: center
        align-items: center
        flex-direction: column

        .dates-wrapper
          display: flex
          flex-direction: column
        .seen
          background-color: #94b3e9;
          color: #fff23;
          padding: 0px 4px;
          margin-top: 3px;
          border-radius: 4px;
  @media (max-width: 520px)
    .boton-container
      .margin-button-top
        margin-top 5px
</style>



// WEBPACK FOOTER //
// Component_Reporte_Documentos_Firmar.vue?40e2e938